export default __webpack_public_path__ + "static/media/It-service-1.13ce9a8a.jpeg";